import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Grid, Stack, Typography } from '@mui/material';
import { StyledPaperItem } from '../common/mui-components';

type PropTypes = {
  close: () => void;
  onCategoryBanClick: () => void;
  open: boolean;
};

export const BanCategoriesInfoDialog = ({
  close,
  onCategoryBanClick,
  open,
}: PropTypes) => {
  return (
    <Dialog open={open} onClose={close} maxWidth="md">
      <DialogTitle>
        <Typography variant="h5" textAlign={'center'} letterSpacing={5}>
          Did you know?
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ width: '100%', height: '100%' }}>
        <Grid container spacing={2} className="CONTAINER-MAIN">
          <Grid item xs={12} sm={12} className="MID">
            <StyledPaperItem>
              <Stack spacing={2}>
                <Typography>
                  In ranked games, you can ban a category!
                </Typography>
                <Typography>
                  We understand that not every category PAR has to offer may be
                  of interest. For example, a lot of people don't like Math! So
                  everyone is allowed to ban one category in ranked games.
                </Typography>
                <Typography>
                  There is one rule: for a ban to take effect, a category must
                  be banned by at least 50% of the players in the game
                </Typography>
                <Typography>
                  Click the button below to ban a category now. You can also do
                  this in your Profile - Game Settings or in the Play Menu
                  sidebar under "Ranked"
                </Typography>
              </Stack>
            </StyledPaperItem>
          </Grid>
          <Grid item xs={12} sm={12} className="CONTAINER-TOP">
            <Stack sx={{ display: 'flex', alignItems: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                sx={{
                  letterSpacing: 5,
                  width: '50%',
                }}
                onClick={onCategoryBanClick}
              >
                Ban Category
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={close} fullWidth>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
